import React, {useMemo, useState} from 'react'
import { Icon, Overlay } from '@wmgtech/legato'

import { cn } from 'shared/utils'

import { ZoneMenuWrapperProps } from './ZoneMenu.props'
import './ZoneMenu.scss'

const ZoneMenu = ({ children, currentLabelTitle, countryCode = '', currentSpace }: ZoneMenuWrapperProps) => {
  const [isActive, setIsActive] = useState(false)

  const title = useMemo(() => {
    if (currentSpace?.id && currentSpace?.name) {
      return `${currentSpace.name} / ${countryCode} `
    }
    if (currentLabelTitle && countryCode) {
      return `${currentLabelTitle} / ${countryCode} `
    }
    return ''
  }, [currentSpace, countryCode, currentLabelTitle])

  return (
    <Overlay
      open={isActive}
      showFang={false}
      trigger={(
        <div className="zone-menu__dropdown-btn">
          <span className={cn('zone-menu__title', { 'zone-menu__title--active': isActive })}>
            {title}
          </span>
          <Icon className="zone-menu__icon" name="circle-chevron-down" prefix={isActive ? 'fas' : 'fal'} />
        </div>
      )}
      placement="bottom-start"
      onOpenChange={setIsActive}
    >
      <div className="zone-menu__dropdown">{children}</div>
    </Overlay>
  )
}

export default ZoneMenu
